import { useCacheSlice } from '../hooks'

export type Matter = {
  matter: string
  matter_id: string
  client: string
  description: string
  task_group: string
  activity_group: string
  is_recent?: number
  recency_rank?: number | null
}

export function useMattersCache() {
  const { data, isLoading, lastFetchedAt } = useCacheSlice('matters')
  const matters = data as Matter[]
  // Only signal loading on the initial fetch — background refetches (window focus,
  // etc.) should not affect taskRequired/activityRequired derived state.
  const isInitialLoading = isLoading && lastFetchedAt === 0
  return { matters, isLoading: isInitialLoading }
}
